import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const AppliedFiltersRow = styled.ul`
  padding: 10px 0;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  display: flex;
  list-style: none;
  flex-direction: row;
  font-size: 12px;

  li {
    background: ${({ theme }) => theme.defaultColors.lighterGrey};
    border-radius: 999px;
    margin-right: 8px;
    padding: 7px 22px;
  }
`;

export const MobileInnerContainer = styled.div`
  display: flex;
  position: relative;
  height: calc(100% - 50px);
  min-height: 325px;
  flex-direction: column;
  padding: 20px;
`;

export const MobileContainer = styled.div`
  padding: 20px 0 0 0;

  ${media.md`
    display: none;
  `}
`;

export const DesktopContainer = styled.div`
  display: none;
  padding-top: 5px;

  ${media.md`
    display: flex;
    align-item: center;
  `}
`;

export const SeparatorWrapper = styled.span`
  padding: 0 5px;
`;

export const GuestHeadingContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 5px;
  align-items: center;
  transform: translateY(3px);
`;
